<template>
  <div class="product-card" v-if="selectedVariant != null && selectedVariant.variants">
    <span class="product-card__badge" :class="customBadgeColor" v-if="hasCustomBadge" v-html="customBadgeText"></span>
    <span class="product-card__badge hidden-badge" aria-hidden="true" v-else>no badge</span>
    <div class="pointer-events-visible u-pointer" @click="openQuickview($event)" @keyup.enter="openQuickview($event)" tabindex="0">
      <div class="product-card__image-holder" ref="productCardImage" v-if="hasImages" @mouseenter="imageHover" @mouseleave="imageLeave">
        <img :alt="selectedVariant.title" class="product-card__image" :src="productImage" />
        <div class="product-card__hover-icon" v-if="imageHovered">
          <Icon name="search" size="20px"></Icon>
        </div>
      </div>
      <div class="product-card__image-holder" ref="productCardImage" v-else @mouseenter="imageHover" @mouseleave="imageLeave">
        <img class="product-card__image" :src="placeholderImage" alt="Product Placeholder Image" />
        <div class="product-card__hover-icon" v-if="imageHovered">
          <Icon name="search" size="20px"></Icon>
        </div>
      </div>
    </div>
    <a class="pointer-events-visible product-card__info-box-wrapper" :href="`/products/${productData.product.handle}`">
      <div class="product-card__info-box" v-if="selectedVariant.variants">
        <button
          v-if="BVAGlobal.customerTags != null && productData.product.type != 'variant' && !hasRestrictWebSale"
          type="button"
          name="addToWishList"
          aria-label="Toggle Wishlist" 
          :id="`addToWishList-${selectedVariant.id}`"
          class="product-card__wishlist-btn product-form__cart-submit"
          @click="toggleWishlist(selectedVariant.id, selectedVariant.handle, selectedVariant.variants[0].id, $event,selectedVariant.title)">
          <template v-if="wishlistLoaderVisible">
            <span id="wishListLoader">
              <Icon name="checkmark" size="16px"></Icon>
            </span>
          </template>
          <template v-else>
            <span class="heart-empty">
              <Icon name="heart-empty" size="16px"></Icon>
            </span>
            <span class="heart-full">
              <Icon name="heart-full" size="16px"></Icon>
            </span>
          </template>
        </button>
        <template v-if="hasRestrictWebSale">
        </template>
        <template v-else-if="productData.product.type == 'variant'">
          <span v-if="childProducts.length > 0" class="product-card__price" v-html="convertCurrency(selectedVariant.variants[0].price)"></span>
          <span class="product-card__compare-at-price" v-if="(currentPrice * 100) < selectedVariant.variants[0].price" v-html="formatPrice(selectedVariant.variants[0].price)"></span>
        </template>
        <template v-else-if="isSetsProductType"> </template>
        <template v-else>
          <span class="product-card__price" v-html="convertCurrency(selectedVariant.variants[0].price)"></span>
          <span class="product-card__compare-at-price" v-if="(currentPrice * 100).toFixed(0) < selectedVariant.variants[0].price" v-html="formatPrice(selectedVariant.variants[0].price)"></span>
        </template>
        <p v-if="selectedVariant.variants[0].sku && productData.product.type != 'variant'" class="product-card__sku" v-html="selectedVariant.variants[0].sku"></p>
        <p v-if="hasMinQtyAboveOne && productData.product.type != 'variant'" class="min-qty">Minimum {{getMinQtyAboveOne}} Qty</p>
        <h1 class="product-card__title" v-html="productData.product.title"></h1>
      </div>
    </a>

    <template v-if="isToolStorage">
      <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Call 800-MACTOOLS</button>
    </template>
    <template v-else-if="hasReplacement">
      <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Discontinued</button>
    </template>
    <template v-else-if="isStudent">
      <template v-if="isVariantProductType">
        <div class="product-card-form__holder">
          <button @click="openQuickview($event)" @keyup.enter="openQuickview($event)" class="button button--primary" tabindex="0">View Options</button>
        </div>
      </template>
      <template v-else-if="!isAvailable">
        <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Call 800-MACTOOLS</button>
      </template>
      <template v-else-if="hasRestrictWebSale">
        <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Call 800-MACTOOLS</button>
      </template>
      <template v-else-if="discontinueEmpty">
        <template v-if="isSetsProductType">
        <div class="product-card-form__holder one">
        <button @click="addToCartSet(selectedVariant.variants[0].id)" class="button button--primary" tabindex="0">Add to cart</button>
        </div>
        </template>
        <template v-else>
        <div class="product-card-form__holder one">
          <button @click="addToCart(selectedVariant.variants[0].id)" class="button button--primary" tabindex="0">Add to cart </button>
        </div>
        </template>
      </template>
      <template v-else-if="!discontinueEmpty">
        <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Discontinued</button>
      </template>
    </template>
    <template v-else-if="isStudent && !studentCanBuy">
      <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Not Available</button>
    </template>
    <template v-else-if="hasMTSchool == 'not available'">
      <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Not Available</button>
    </template>
    <template v-else-if="hasBeenPurchased">
      <div class="product-card-form__holder">
        <a v-if="isMobile" :href="`/products/${productData.product.handle}`" class="button button--primary">View Options</a>
        <a v-else @click="openQuickview($event)" @keyup.enter="openQuickview($event)" class="button button--primary" tabindex="0">View Options</a>
      </div>
    </template>
    <template v-else-if="!hasSalesChannelFlag">
      <div class="product-card-form__holder">
        <a v-if="isMobile" :href="`/products/${productData.product.handle}`" class="button button--primary">View Options</a>
        <a v-else @click="openQuickview($event)" @keyup.enter="openQuickview($event)" class="button button--primary" tabindex="0">View Options</a>
      </div>
    </template>
    <template v-else-if="isVariantProductType">
      <template v-if="isMobile">
        <div class="product-card-form__holder">
          <a :href="`/products/${productData.product.handle}`" class="button button--primary" tabindex="0">View Options</a>
        </div>
      </template>
      <template v-else>
        <div class="product-card-form__holder">
          <button @click="addToCart(selectedVariant.variants[0].id)" class="button button--primary" tabindex="0">View Options</button>
        </div>
      </template>
    </template>
    <template v-else-if="isSetsProductType">
      <template v-if="isMobile">
        <div class="product-card-form__holder">
          <button @click="addToCartSet(selectedVariant.variants[0].id)" class="button button--primary" tabindex="0">Add to cart</button>
          <!-- <a :href="`/products/${productData.product.handle}`" class="button button--primary" tabindex="0">View Sets</a> -->
        </div>
      </template>
      <template v-else>
        <div class="product-card-form__holder">
          <button @click="addToCartSet(selectedVariant.variants[0].id)" class="button button--primary" tabindex="0">Add to cart</button>
          <!-- <a :href="`/products/${productData.product.handle}`" class="button button--primary" tabindex="0">View Sets</a> -->
        </div>
      </template>
    </template>
    <template v-else>
      <template v-if="!isAvailable">
        <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Call 800-MACTOOLS</button>
      </template>
      <template v-else-if="hasRestrictWebSale">
        <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Call 800-MACTOOLS</button>
      </template>
      <template v-else>
        <template v-if="isSetsProductType">
        <div class="product-card-form__holder one">
        <button @click="addToCartSet(selectedVariant.variants[0].id)" class="button button--primary" tabindex="0">Add to cart</button>
        </div>
        </template>
        <template v-else>
        <div class="product-card-form__holder two">
          <button @click="addToCart(selectedVariant.variants[0].id)" class="button button--primary" tabindex="0">Add to cart</button>
        </div>
        </template>
      </template>
    </template>
    <modal class="quickview-modal" ref="quickview" :useTransition="false">
      <template slot="content">
        <product-top class="pdp-top--quickview" :data="quickviewData" :isQuickview="true"></product-top>
      </template>
    </modal>
  </div>
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import Modal from 'scripts/components/basic/Modal.vue';
  import ProductTop from 'scripts/components/product/ProductTop.vue';

  /**
   * @namespace ProductCard
   * @desc This component serves as a wrapper for the PDP Before + After section.
   *     In the future, this component will integrate with modal and lightbox
   *     components to display images in a lightbox carousel, which is why its
   *     being passed props that aren't used at the moment (3/8/21).
   *     SCSS is written in the global stylesheet to avoid layout shift during render.
   */
  export default {
    name: 'ProductCard',
    components: {
      Icon,
      Modal,
      ProductTop
    },
    props: {
      data: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      quickviewData: {
        type: String,
        default: '',
      },
      inSlider: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      getChildProducts(data) {
        let parsedData = JSON.parse(productData.product.description);
        let childProductIDs = parsedData.childproducts.childproduct;
        for (let i = 0; i < childProductIDs.length; i++) {
          if (childProductIDs[i] !== '') {
            let fetchURL = '/search?type=product&q=variants.sku:' + childProductIDs[i] + '&view=sku';
            fetch(fetchURL)
              .then((response) => response.json())
              .then((prodData) => this.childProducts.push(prodData))
              .then(() => this.selectedVariant = this.childProducts[0].products[0]);
          }
        }
      },
      changeVariant(newVariant) {
        this.selectedVariant = newVariant;
      },
      changeVariantDropdown(newVariant) {
        let selectedValue = parseInt(newVariant.srcElement.value);
        for (let i = 0; i < this.childProducts.length; i++) {
          if (this.childProducts[i].products[0].variants[0].id === selectedValue) {
            this.selectedVariant = this.childProducts[i].products[0];
          }
        }
      },
      addToCart(variantToAdd) {
        if(!this.isMobile && this.isVariantProductType) {
          this.openQuickview();
          return;
        };
        let scopedThis = this;
        let extraProperties = {};
        let minQtyCard = 1;
        let packQtySuffix = 1;

        extraProperties['SKU'] = this.selectedVariant.variants[0].sku;
        extraProperties['compare_price'] = this.selectedVariant.variants[0].compare_at_price;

        if (this.thresholdReached) {
          extraProperties['STP discount limit exceeded'] = 'Item added at regular price';
        }

        if (this.isStudent) {
          extraProperties['_stp_price'] = this.currentPrice;
          extraProperties['_amount_spent'] = parseFloat(this.BVAGlobal.customerSpent);
          extraProperties['_discount_limit'] = this.discountLimit;
        }

        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if (this.selectedVariant.tags[i].includes('EP:UpsFreightOverride|')) {
            // split it and add it
            let freightSuffix = this.selectedVariant.tags[i].split('|');
            if (freightSuffix.includes('F')) {
              extraProperties['Shipped By'] = 'Freight';
            } else if (freightSuffix.includes('U')) {
              extraProperties['Shipped By'] = 'UPS';
            }
          }
          if (this.selectedVariant.tags[i].includes('EP:MinimumQty|')) {
            let minQtyCardSuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
            if (minQtyCardSuffix>1) {
                minQtyCard = minQtyCardSuffix;
            }
          }
          if (this.selectedVariant.tags[i].includes('EP:PackQty|')) {
            packQtySuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
            if (packQtySuffix > 1) {
              extraProperties['_packSize'] = packQtySuffix;
            }
          }
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            id: variantToAdd,
            quantity: minQtyCard,
            properties: extraProperties,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function() {
          fetch('/cart.js')
            .then((response) => response.json())
            .then((cartData) => scopedThis.openMiniCart(cartData));
        });

        window.scroll({top: 0, left: 0, behavior: 'smooth'});
      },
      addToCartSet(variantToAdd) {
        if(!this.isMobile && this.isVariantProductType) {
          this.openQuickview();
          return;
        };
        let scopedThis = this;
        let extraProperties = {};
        let minQtyCard = 1;
        let packQtySuffix = 1;
        extraProperties['SKU'] = this.selectedVariant.variants[0].sku;
        extraProperties['compare_price'] = this.selectedVariant.variants[0].compare_at_price;
        if (this.thresholdReached) {
          extraProperties['STP discount limit exceeded'] = 'Item added at regular price';
        }
        if (this.isStudent) {
          extraProperties['_stp_price'] = this.currentPrice;
          extraProperties['_amount_spent'] = parseFloat(this.BVAGlobal.customerSpent);
          extraProperties['_discount_limit'] = this.discountLimit;
        }
        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if (this.selectedVariant.tags[i].includes('EP:UpsFreightOverride|')) {
            // split it and add it
            let freightSuffix = this.selectedVariant.tags[i].split('|');
            if (freightSuffix.includes('F')) {
              extraProperties['Shipped By'] = 'Freight';
            } else if (freightSuffix.includes('U')) {
              extraProperties['Shipped By'] = 'UPS';
            }
          }
          if (this.selectedVariant.tags[i].includes('EP:MinimumQty|')) {
            let minQtyCardSuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
            if (minQtyCardSuffix>1) {
                minQtyCard = minQtyCardSuffix;
            }
          }
          if (this.selectedVariant.tags[i].includes('EP:PackQty|')) {
            packQtySuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
            if (packQtySuffix > 1) {
              extraProperties['_packSize'] = packQtySuffix;
            }
          }
        }
        let newSetQuery =[{
            id: variantToAdd,
            quantity: minQtyCard,
            properties: extraProperties,
          },...this.setProductQuery]
      let chunks = 5;
      let setQuerySize = newSetQuery.length/chunks;
      if((newSetQuery.length%chunks) >= 1){
        setQuerySize = Math.ceil(setQuerySize);
      }
      function sliceIntoChunks(arr, chunkSize) {
          const res = [];
          for (let i = 0; i < arr.length; i += chunkSize) {
              const chunk = arr.slice(i, i + chunkSize);
              res.push(chunk);
          }
          return res;
      }
      let setChunks = sliceIntoChunks(newSetQuery, chunks);
      setChunks.forEach((element,i) => {
        setTimeout(
            function(){
              let formData = {
                'items': element
              };
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                if(++i == setQuerySize){
                fetch('/cart.js')
                  .then((response) => response.json())
                  .then((cartData) => scopedThis.openMiniCart(cartData));
                  window.scroll({top: 0, left: 0, behavior: 'smooth'});
                }
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            }
        , i * 4000);
      });
      },

      async addWishListItem(productID, handle, variantID,title) {
        this.showWishListLoader(true);
        const qty = this.quantity;
        const customerID = this.BVAGlobal.customerID;
        if (!customerID || customerID === 0 || !productID || productID === 0 || !handle || handle === 0 || !variantID || variantID === 0) {
          return
        }

        const url = this.productData.endpoint + '/addWishListItem';
        const item = { customerId: customerID, productId: productID, handle: handle, variantId: variantID, qty: qty, title:title }

        try {
          let scopedThis = this;
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'token': this.productData.token,
              'mode': 'no-cors',
            },
            body: JSON.stringify(item),
          });

          const data = await response.json();

          if (!data.result) {
            console.log(data.message);
          } else {
            document.getElementById("addToWishList-" + this.selectedVariant.id).setAttribute('data-wishlist-id', data.data.wishListItemId);
            const wishListItem = data.data;
            this.getWishListItems();
          }
          scopedThis.showWishListLoader(false);

        } catch (error) {
          this.showWishListLoader(false);
        }
      },
      async removeWishListItem(productID, handle, variantID) {
        this.showWishListLoader(true);
        const qty = this.quantity;
        const customerID = this.BVAGlobal.customerID;
        const wishlistItemID = document.getElementById("addToWishList-" + this.selectedVariant.id).getAttribute('data-wishlist-id');
        if (!customerID || customerID === 0) {
          return
        }

        const url = this.productData.endpoint + '/removeWishListItem';
        const item = { customerId: customerID, wishListItemId: wishlistItemID }

        try {
          let scopedThis = this;
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'token': this.productData.token,
              'mode': 'no-cors',
            },
            body: JSON.stringify(item),
          });
          const data = await response.json();
          if (!data.result) {
          } else {
            document.querySelector('#addToWishList-' + this.selectedVariant.id).classList.remove('btn-disabled');
            scopedThis.showWishListLoader(false);
          }
        } catch (error) {
          this.showWishListLoader(false);
        }
      },
      toggleWishlist(productID, handle, variantID, event,title) {
        event.preventDefault();
        
        if (document.querySelector('#addToWishList-' + this.selectedVariant.id).classList.contains('btn-disabled')) {
          this.removeWishListItem(productID, handle, variantID);
        } else {
          this.addWishListItem(productID, handle, variantID,title);
        }
      },
      showWishListLoader(show) {
        const loader = document.getElementById("wishListLoader");
        if (show) {
          this.wishlistLoaderVisible = true;
        }
        else {
          this.wishlistLoaderVisible = false;
        }
      },
      async getWishListItems() {
        const url = this.productData.endpoint + '/getWishListItems/' + this.BVAGlobal.customerID;
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'token': this.productData.token
            }
          });
          const data = await response.json();
          if (!data.result) {
            console.log(data.message);
          }
          else {
            this.wishListItems = data.data.filter(item => parseInt(item.ProductID) == this.selectedVariant.id);
            this.updateAddToWishListCtrl();
          }
        } catch (error) {
          console.error('Error:', error);
        }
      },
      updateAddToWishListCtrl() {
        const hasOnlyDefaultVariant = this.selectedVariant.variants[0].title == "Default Title";
        if (hasOnlyDefaultVariant) {
          this.updateWishListButtonByVariant(this.selectedVariant.variants[0].id);
        }
        else {
          // Disable controls for products with variants
        }
      },
      updateWishListButtonByVariant(id) {
        if (this.wishListItems.length > 0) {
          const found = this.wishListItems.find(itm => itm.VariantID == id);
          this.disableAddToWishListButton(found != undefined);
        }
      },
      disableAddToWishListButton(disable) {
        const btn = document.getElementById("addToWishList-" + this.selectedVariant.id);
        // btn.disabled = disable;
        btn.classList.add("btn-disabled");
      },
      async checkWishlist() {
        if(this.BVAGlobal.customerID != 0) {
          const url = this.productData.endpoint + '/getWishListItems/' + this.BVAGlobal.customerID;
          try {
            const response = await fetch(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'token': this.productData.token
              }
            });
            const data = await response.json();
            if (!data.result) {
              console.log(data.message);
            }
            else {
              for (let i = 0; i < data.data.length; i++) {
                if (data.data[i].Handle == this.selectedVariant.handle) {
                  document.getElementById("addToWishList-" + this.selectedVariant.id).setAttribute('data-wishlist-id', data.data[i].WishListItemID);
                  this.disableAddToWishListButton(true);
                }
              }
            }
          } catch (error) {
            console.error('Error:', error);
          }
        }
      },
      convertCurrency(value) {
        if(this.BVAGlobal.customerID != 0) {
          let customerTags  = this.BVAGlobal.customerTags.join(',');
          if(customerTags.includes('UserType:STPStudent')) {
            if(this.getPrice('PRICE:STP|') != false && !this.thresholdReached && this.studentCanBuy) {
              this.currentPrice = parseFloat(this.getPrice('PRICE:STP|'));
              return '$' + this.getPrice('PRICE:STP|');
            }
            this.currentPrice = value / 100;
            return '$' + (value / 100).toFixed(2);
          }
          if(customerTags.includes('UserType:Punchout')) {
            if(this.getPrice('PRICE:PO|') != false) {
              this.currentPrice = parseFloat(this.getPrice('PRICE:PO|'));
              return '$' + this.getPrice('PRICE:PO|');
            }
            this.currentPrice = value / 100;
            return '$' + (value / 100).toFixed(2);
          }
          if(customerTags.includes('UserType:STPStaff')) {
            if(this.getPrice('PRICE:STP|') != false) {
              this.currentPrice = parseFloat(this.getPrice('PRICE:STP|'));
              return '$' + this.getPrice('PRICE:STP|');
            }
            this.currentPrice = value / 100;
            return '$' + (value / 100).toFixed(2);
          }
          if(customerTags.includes('UserType:NationalPartner')) {
            if(this.getPrice('PRICE:NP|') != false) {
              this.currentPrice = parseFloat(this.getPrice('PRICE:NP|'));
              return '$' + this.getPrice('PRICE:NP|');
            }
            this.currentPrice = value / 100;
            return '$' + (value / 100).toFixed(2);
          }
          if(customerTags.includes('UserType:Regular')) {
            this.currentPrice = value / 100;
            return '$' + (value / 100).toFixed(2);
          }
        }
        this.currentPrice = value / 100;
        return '$' + (value / 100).toFixed(2);
      },
      formatPrice(incomingPrice) {
        let priceValue = incomingPrice / 100
        return priceValue.toLocaleString("en-US", {style:"currency", currency:"USD"});
      },
      getPrice(priceType) {
        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if(this.selectedVariant.tags[i].includes(priceType)) {
            return this.selectedVariant.tags[i].split(priceType)[1];
          }
        }
        return false;
      },
      discountLimitCheck() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')){
          let customerTags = this.BVAGlobal.customerTags.join(',');
          if (customerTags.includes('discount_limit:')){
            for (let i = 0; i < this.BVAGlobal.customerTags.length; i++) {
              if (this.BVAGlobal.customerTags[i].includes('discount_limit:')) {
                this.discountLimit = parseInt(this.BVAGlobal.customerTags[i].split(':')[1]);
              }
            }
          }
        }
      },
      openMiniCart(cartData) {
        let cartContainer = document.querySelector('#mini-cart');
        let cartHTML = "";
        let totalSavings = 0;
        if (cartData.items.length > 0) {
          cartHTML += `
            <div class="mini-cart__inner">
              <div class="mini-cart__content">
                <div class="mini-cart__line-item-list">
          `;
          for (let i = 0; i < cartData.items.length; i++) {
            let lineItem = cartData.items[i];
            let priceHTML = "";
            let propertiesHTML = "";
            let comparePrice = 0;
            for (const [key, value] of Object.entries(lineItem.properties)) {
              if (key == 'compare_price') {
                comparePrice = value;
              } else if (key == 'Shipped By' || key == 'STP discount limit exceeded' || key == 'SKU') {
                propertiesHTML += `
                  <li class="mini-cart__property"><strong>${key}</strong>: ${value}</li>
                `;
              }
            }
            if (lineItem.price < comparePrice) {
              priceHTML = `
                <span class="price price--highlight">${this.formatPrice(lineItem.final_line_price)}</span>
                <span class="price price--compare">${this.formatPrice(comparePrice * lineItem.quantity)}</span>
              `;
              totalSavings += ((comparePrice - lineItem.price) * lineItem.quantity);
            } else {
              priceHTML = `
                <span class="price price--highlight">${this.formatPrice(lineItem.final_line_price)}</span>
              `;
            }
            let imageHTML = '';
            if (lineItem.image) {
              imageHTML = `<img src="${lineItem.image}" alt="${lineItem.title}">`
            } else {
              imageHTML = `<img src="${lineItem.image}" style='opacity: 0;' alt="${lineItem.title}">`
            }
            let lineItemHTML = `
              <div class="mini-cart__line-item var_${lineItem.id}">
                <div class="mini-cart__image-wrapper">
                  <div class="aspect-ratio" style="padding-bottom: 100.0%">
                    ${imageHTML}
                  </div>
                </div>
                <div class="mini-cart__item-wrapper">
                  <div class="mini-cart__product-info">
                    <a href="/products/${lineItem.handle}?variant=${lineItem.id}" class="mini-cart__product-title text--strong link">${lineItem.title}</a>
                    <ul class="mini-cart__property-list" role="list">
                      ${propertiesHTML}
                    </ul>
                    <div class="mini-cart__price-list">
                      ${priceHTML}
                    </div>
                  </div>
                  <div class="mini-cart__quantity">
                    <div class="quantity-selector">
                      <button class="quantity-selector__button" data-action="decrease-quantity" data-quantity="${lineItem.quantity - 1}" data-line="${i + 1}" aria-label="Decrease quantity" title="Decrease quantity">
                        <svg focusable="false" class="icon icon--minus" viewBox="0 0 10 2" role="graphics-symbol">
                          <path d="M10 0v2H0V0z" fill="currentColor"></path>
                        </svg>
                      </button>
                      <input aria-label="Quantity" class="quantity-selector__value" inputmode="numeric" data-current-value="${lineItem.quantity}" data-line="${i + 1}" value="${lineItem.quantity}" size="2">
                      <button class="quantity-selector__button" data-action="increase-quantity" data-quantity="${lineItem.quantity + 1}" data-line="${i + 1}" aria-label="Increase quantity" title="Increase quantity">
                        <svg focusable="false" class="icon icon--plus" viewBox="0 0 10 10" role="graphics-symbol">
                          <path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"></path>
                        </svg>
                      </button>
                    </div>
                    <a href="/cart/change?quantity=0&amp;line=1" data-action="decrease-quantity" data-quantity="0" data-line="${i + 1}" class="mini-cart__quantity-remove link">Remove</a>
                  </div>
                </div>
              </div>
            `;
            cartHTML += lineItemHTML;
          }

          let savingsHTML = '';
          if(totalSavings > 0) {
            savingsHTML = `<span class="mini-cart__amount-saved">You saved <span>${this.formatPrice(totalSavings)}</span>!</span>`
          }
          cartHTML += `
                </div>
                <div class="mini-cart__recap">
                  <div class="mini-cart__recap-price-line">
                    <span>Total</span>
                    <span>&nbsp;${this.formatPrice(cartData.total_price)}</span>
                  </div>
                  ${savingsHTML}
                  <div class="mini-cart__button-container">
                    <div class="button-group button-group--loose button-group--fit">
                      <a href="/cart" class="button button--secondary">View cart</a>
                      <button type="submit" name="checkout" class="button button--primary">Checkout</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          `;
        } else {
          cartHTML = `
            <div class="mini-cart__content mini-cart__content--empty">
              <div class="mini-cart__empty-state">
                <svg focusable="false" width="81" height="70" viewBox="0 0 81 70">
                  <g transform="translate(0 2)" stroke-width="4" stroke="#1e2d7d" fill="none" fill-rule="evenodd">
                    <circle stroke-linecap="square" cx="34" cy="60" r="6"></circle>
                    <circle stroke-linecap="square" cx="67" cy="60" r="6"></circle>
                    <path d="M22.9360352 15h54.8070373l-4.3391876 30H30.3387146L19.6676025 0H.99560547"></path>
                  </g>
                </svg>
                <p class="heading h4">Your cart is empty</p>
              </div>
              <a href="/collections/all" class="button button--primary button--full">Shop our products</a>
            </div>
          `;
        }

        0//cartContainer.innerHTML = cartHTML;
        //document.querySelector('.header__cart-count').innerHTML = cartData.item_count;
        //document.querySelector('.header__cart-toggle').click();

        setTimeout(function(){ 
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
              quantity: 1
            }
          }));
        }, 500);


      },
      openQuickview(event) {
        if(event){ event.preventDefault();}

        if(this.inSlider){
          this.$emit('sliderQuickview', this.quickviewData)
        } else {
          if (!this.isMobile && (this.hasChildProducts || this.hasBeenPurchased || !this.isVariantProductType)) {
            this.$refs.quickview.open();
          }
        }
      },
      imageHover (event) {
        if (this.$refs.productCardImage === event.target) {
          this.imageHovered = true;
        }
      },
      imageLeave (event) {
        if (this.$refs.productCardImage === event.target) {
          this.imageHovered = false;
        }
      },
      cartCheck() {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cartData) => {
            for (let i = 0; i < cartData.items.length; i++) {
              if (this.selectedVariant){
                if (cartData.items[i].id == this.selectedVariant.variants[0].id) {
                  if (!this.hasBeenPurchased) {
                    this.productInCart = true;
                  }
                }
              }
            }
          }
        );
      },

      getChildProductsSet(childProductsHandles){
        let count = 0;
        childProductsHandles.forEach((handle, index) => {
          if (handle !== '') {
            let fetchURL = '/search?type=product&q=variants.sku:' + handle + '&view=sku';
            fetch(fetchURL)
              .then((response) => response.json())
              .then((prodData) => {
                if (prodData.products.length > 0) {
                  this.allChildProducts.push(prodData);
                  //console.log("index",index, prodData);
                  this.quantities[count]=this.getMinQtyAboveOneCountSet(prodData.products[0].tags);
                  this.packSize[count]=this.getPackQtyAboveOneCountSet(prodData.products[0].tags);

                  if(prodData.products[0].available){
                  this.setProductQuery.push({
                  id:prodData.products[0].variants[0].id,
                  quantity:this.quantities[count]
                  })}
                  count++;                
                }
              });
          }
        });
      },
      getMinQtyAboveOneCountSet(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('EP:MinimumQty|')) {
          for (let i  = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('EP:MinimumQty|')) {
              let qtySuffix = parseInt(childProductTags[i].split('|')[1]);
              if (qtySuffix > 1) {
                return qtySuffix;
              }
            }
          }
        }
        return 1;      
      },
      getPackQtyAboveOneCountSet(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('EP:PackQty|')) {
          for (let i  = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('EP:PackQty|')) {
              let packQtySuffix = parseInt(childProductTags[i].split('|')[1]);
              if (packQtySuffix > 1) {
                return packQtySuffix;
              }
            }
          }
        }
        return 1;      
      },
    },
    computed: {
      isToolStorage() {
        let collectionTitleArray = [
          'Utility Carts',
          'Workbenches and Cabinets',
          'Tech™ Workstations',
          'Tech™ Top Attachments',
          'Tech™ Side Attachments',
          'Tech™ Work Surfaces',
          'Edge™ Workstations',
          'Edge™ Top Attachments',
          'Edge™ Work Surfaces',
          'Utility Cart Attachments and Accessories',
          'Macsimizer® HD Workstations',
          'Macsimizer® HD Top Attachments',
          'Macsimizer® HD Side Attachments',
          'Macsimizer® HD Work Surfaces',
          'Macsimizer® Workstations',
          'Macsimizer® Top Attachments',
          'Macsimizer® Side Attachments',
          'Macsimizer® Work Surfaces'
        ]
        let tags = '';
        if (this.productData.productCollections != undefined) {
          tags = this.productData.productCollections.join(',');
          for (let i = 0; i < this.productData.productCollections.length; i++) {
            for (let j = 0; j < collectionTitleArray.length; j++) {
              if (this.productData.productCollections[i].title == collectionTitleArray[j]) {
                return true
              }
            }
          }
        }
        return false;
      },
      hasReplacement() {
        let tags = '';
        if (this.selectedVariant.tags != undefined) {
          tags = this.selectedVariant.tags.join(',');
        }
        if (tags.includes('EP:ReplacementItemNum|') || tags.includes('EP:DiscontinueCode|D')) {
          for (let i = 0; i < this.selectedVariant.tags.length; i++) {
            if(this.selectedVariant.tags[i].includes('EP:ReplacementItemNum|')) {
              if (this.selectedVariant.tags[i].split('|')[1]) {
                return false;
              }
              return false;
            }
          }
          return false;
        }
        return false;
      },
      hasChildProducts() {
        let parsedData = JSON.parse(this.selectedVariant.description);
        if (parsedData.childproducts) {
          return true;
        }
        return false;
      },
      hasCustomBadge() {
        let tags = '';
        if (this.selectedVariant.tags != undefined) {
          tags = this.selectedVariant.tags.join(',');
        }
        if (tags.includes('badge::')) {
          return true;
        }
        return false;
      },
      customBadgeColor() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('badge::new')) {
          return 'new';
        }
        if (tags.includes('badge::sale')) {
          return 'sale';
        }
        return 'custom';
      },
      customBadgeText() {
        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if (this.selectedVariant.tags[i].includes('badge::')) {
            return this.selectedVariant.tags[i].split('::')[1]
          }
        }
        return '';
      },
      hasMTSchool() {
        if(this.BVAGlobal.customerID != 0) {
          let customerTags  = this.BVAGlobal.customerTags.join(',');
          let tags = '';
          if (this.selectedVariant.tags != undefined) {
            tags = this.selectedVariant.tags.join(',');
          }
          let productSchools = [];
          for (let i = 0; i < this.selectedVariant.tags.length; i++) {
            let splitTag = this.selectedVariant.tags[i].split(':');
            if (splitTag[0] == "MT_School") {
              productSchools.push(splitTag[1]);
            }
          }
          if (customerTags.includes('UserType:STPStudent') && productSchools.includes(this.BVAGlobal.customerSchool)) {
            return 'active';
          }
        }
        return false;
      },
      hasBeenPurchased() {
        if(this.BVAGlobal.customerID != 0) {
          let customerTags  = this.BVAGlobal.customerTags.join(',');
          if (customerTags.includes('UserType:STPStudent') && customerTags.includes(this.selectedVariant.variants[0].sku)) {
            return true;
          }
        }
        return false;
      },
      hasSalesChannelFlag() {
        let tags = '';
        if (this.selectedVariant.tags != undefined) {
          tags = this.selectedVariant.tags.join(',');
        }
        if (!tags.includes('EP:WebSalesChannelFlag|true')) {
          return false;
        }
        return true;
      },
      hasRestrictWebSale() {
        let tags = '';
        if (this.selectedVariant.tags != undefined) {
          tags = this.selectedVariant.tags.join(',');
        }
        if (tags.includes('Restrict_web_sale') || tags.includes('restrict_web_sale')) {
          return true;
        }
        return false;
      },
      hasMinQtyAboveOne() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('EP:MinimumQty|')) {
          for (let i  = 0; i < this.selectedVariant.tags.length; i++) {
            if (this.selectedVariant.tags[i].includes('EP:MinimumQty|')) {
              let qtySuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
              if (qtySuffix > 1) {
                return true;
              }
            }
          }
        }
        return false;
      },
      getMinQtyAboveOne() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('EP:MinimumQty|')) {
          for (let i  = 0; i < this.selectedVariant.tags.length; i++) {
            if (this.selectedVariant.tags[i].includes('EP:MinimumQty|')) {
              let qtySuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
              if (qtySuffix > 1) {
                return qtySuffix ;
              }
            }
          }
        }
        return false;
      },
      discontinueEmpty() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('EP:DiscontinueCode|')) {
          for (let i  = 0; i < this.selectedVariant.tags.length; i++) {
            if (this.selectedVariant.tags[i].includes('EP:DiscontinueCode|')) {
              let discSuffix = this.selectedVariant.tags[i].split('|')[1];
              if (discSuffix) {
                return false;
              }
            }
          }
        }
        return true;
      },
      studentCanBuy() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')){
          let variantTags = this.selectedVariant.tags.join(',');
          if (variantTags.includes('EP:StudentCanBuy|Y')){
            return true;
          }
        }
        return false;
      },
      isStudent() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')){
          return true;
        }
        return false;
      },
      isChild() {
        let productTags = this.productData.product.tags.join(',');
        if (productTags.includes('child|')) {
          return true;
        }
        return false;
      },
      isVariantProductType() {
        return this.productData.product.type == 'variant'
      },
      isSetsProductType() {
      return this.productData.product.type == 'sets';
      },
      isAvailable() {
        return this.selectedVariant.available;
      },
      thresholdReached() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')){
          if (this.BVAGlobal.customerSpent > this.discountLimit) {
            return true;
          }
        }
        return false;
      },
      hasImages() {
        return this.productData.product && this.productData.product.media && this.productData.product.media.length > 0;
      },
      productImage() {
        if(this.productData.product.media[1] && this.imageHovered){
          let alternateImage = this.productData.product.media[1].src;
          if(alternateImage.includes('.jpg') || alternateImage.includes('.JPG') || alternateImage.includes('.png') || alternateImage.includes('.PNG')){
            return alternateImage
          }
          else {
            return this.productData.product.media[0].src
          }
        }
        let imageString = String(this.productData.product.media[0].src);
        //console.log('def-src',imageString.includes('.jpg'));  
        if(imageString.includes('.jpg') || imageString.includes('.JPG') || imageString.includes('.png') || imageString.includes('.PNG')){
          return this.productData.product.media[0].src
        }
        else {
          return this.productData.product.media[1].src
        }
          
      },
      isMobile () {
        return ['mobile','tablet'].includes(this.$mq);
      },
    },
    data() {
      return {
        productData: {},
        childProducts: [],
        selectedVariant: {},
        placeholderImage: null,
        quantity: 1,
        descriptionAccordion: false,
        warrantyAccordion: false,
        serviceAccordion: false,
        wishlistLoaderVisible: false,
        discountLimit: null,
        wishListItems: [],
        currentPrice: 0,
        BVAGlobal: window.__BVA__,
        imageHovered: false,
        allChildProducts: [],
        quantities: [],
        packSize: [],
        setProductQuery: []
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.productData = JSON.parse(this.data);
        this.selectedVariant = this.productData.product;
        if (this.productData.placeholderImage) {
          this.placeholderImage = this.productData.placeholderImage;
        } else {
          this.placeholderImage = this.BVAGlobal.placeholderImage;
        }
        this.discountLimitCheck();
        this.checkWishlist();
        this.cartCheck();
        if (this.productData.product.type === 'sets' && this.productData.productSet !== null && this.productData.productSet !== undefined) {
        let setArray = this.productData.productSet.split(',');
        let childProductsHandles = setArray;
        this.getChildProductsSet(childProductsHandles);
        }
        // this.productImage = this.productData.product.media[0].src;
        // let productData = JSON.parse(this.data);
        // if (this.productData.product.type === 'variant') {
        //   this.getChildProducts(productData);
        // }
      });
    },
  };
</script>
